import React from 'react';
import { Table } from 'semantic-ui-react';
import './RoomTypeColorCell.css';

const RoomTypeColorCell = ({ value }) => {
  let className = '';
  if (value > 0) {
    className = 'green';
  } else if (value < 0) {
    className = 'red';
  }
  return <Table.Cell className={className}>{value}</Table.Cell>;
};

export default React.memo(RoomTypeColorCell);
